import axios from 'axios'
import { authZeroFetch, AxiosPost, AxiosPut, AxiosDelete } from './AuthZeroFetch'

const SubscribeToPlan = (planId, paymentMethodId, freePlan, promoCode, affiliate) => {
    return authZeroFetch(AxiosPost, '/api/subscription', {
        planId,
        paymentMethodId,
        freePlan,
        promoCode,
        affiliate,
    })
}

const GetSubscription = () => {
    return authZeroFetch(axios.get, '/api/subscription')
}

const ChangeSubscription = (planId, paymentMethodId, promoCode) => {
    return authZeroFetch(AxiosPut, '/api/subscription', {
        planId,
        paymentMethodId,
        promoCode,
    })
}

const CancelSubscription = () => {
    return authZeroFetch(AxiosDelete, '/api/subscription')
}

const UpdateSubscriptionPaymentMethod = (paymentMethodId) => {
    return authZeroFetch(AxiosPut, '/api/subscription/paymentmethod', {
        paymentMethodId,
    })
}

const ConfirmSubscriptionUpdate = () => {
    return authZeroFetch(AxiosPost, '/api/subscription/confirm')
}

const GetSubscriptionCoupon = (couponId, selectedPlanVal) => {
    return authZeroFetch(
        axios.get,
        '/api/subscription/coupon/' + couponId + '?priceId=' + selectedPlanVal
    )
}

export {
    GetSubscription,
    SubscribeToPlan,
    ChangeSubscription,
    CancelSubscription,
    UpdateSubscriptionPaymentMethod,
    ConfirmSubscriptionUpdate,
    GetSubscriptionCoupon,
}
